import { Fitter } from '@sc/data-access-models';
import { Resource } from '../../models';

export class SetFittersAction {
  static readonly type = '[SetFittersAction] Set fitters';

  constructor(public payload: Fitter[]) {}
}

export class SetResourcesAction {
  static readonly type = '[SetResourcesAction] Set resources to hide';

  constructor(public payload: Resource[]) {}
}
